import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import './OverviewImage.scss';

export interface OverviewImageInputs {
    alt: string;
    image: any;
}

export const OverviewImage = ({ inputs }: { inputs: OverviewImageInputs }) => {
    const image = getImage(inputs.image);
    return (
        <GatsbyImage
            alt={inputs.alt}
            image={image}
            className="paragraph__overview-image"
        />
    );
};
